import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { TFMService } from 'app/mock-api/tfm.service';
import { FuseCardComponent } from '@fuse/components/card';

@Component({
  selector: 'app-travel_deals-type01',
  standalone: true,
  imports: [MatIconModule, HeadingSectionType01Component, FuseCardComponent],
  templateUrl: './travel_deals-type01.component.html',
  styleUrl: './travel_deals-type01.component.scss'
})
export class TravelDealsType01Component {

  public view: any = {
    };

    constructor(private _tfmService: TFMService){}

    ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

      });
    }

}
